<template>
  <Button
    :label="label"
    :class="ButtonClass()"
    :style="{
      height: `${height}`,
      width: `${width}`,
      border: `1px solid ${color} !important`,
      color: `${color}`,
      background: `${bgcolor}`,
    }"
    :icon="icon"
    :iconPos="iconPos"
    :loading="loading"
  />
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'Buttons',
  props: [
    'label',
    'icon',
    'button_class',
    'type',
    'bgcolor', // background color of button
    'color', // color of text
    'height',
    'width',
    'iconPos', // position of icon,
    'loading',
  ],
  components: {
    Button,
  },
  methods: {
    ButtonClass() {
      const classes = [];
      classes.push(this.button_class);
      if (this.type === 'primary') {
        classes.push('primary-btn');
      } else if (this.type === 'outline') {
        classes.push('p-button-outlined');
      }
      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';
.primary-btn {
  color: $primary-button-text-color;
  background: $primary-color;
  border: unset !important;
  border-radius: 4px;
  transition: none;

  &:enabled:hover {
    background-color: darken($primary-color, 10%) !important;
  }

  &:enabled:active {
    background-color: darken($primary-color, 20%) !important;
  }
}

.p-button-outlined {
  color: $primary-color;

  &:hover {
    color: $primary-color !important;
  }
}
.p-button {
  font-weight: 800;
  box-shadow: unset !important;

  &:hover {
    background: $primary-color;
  }
}
// .p-button:enabled:active {
//   background: $primary-color !important;
//   border: unset !important;
// }
// .p-button:enabled:hover {
//   background: $primary-color !important;
//   border: unset !important;
// }
</style>
